import React from 'react';
import { Layout, Button, Space, Avatar, Dropdown, Typography } from 'antd';
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    LogoutOutlined,
    BellOutlined
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = ({ collapsed, setCollapsed }) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const location = useLocation();
    const navigate = useNavigate();

    const getPageTitle = (path) => {
        if (path === '/') return 'Dashboard';
        if (path.startsWith('/customers')) return 'Customers';
        if (path.startsWith('/orders')) return 'Orders';
        if (path.startsWith('/leads')) return 'Leads';
        if (path.startsWith('/inventory')) return 'Inventory';
        if (path.startsWith('/vendors')) return 'Vendors';
        if (path.startsWith('/vendor-agreement')) return 'Vendor Agreement';
        if (path.startsWith('/channel-partners')) return 'Channel Partners';
        if (path.startsWith('/purchases')) return 'Purchases';
        if (path.startsWith('/sales')) return 'Sales Invoices';
        if (path.startsWith('/proforma')) return 'Proforma Invoices';
        if (path.startsWith('/payment-milestones')) return 'Payment Milestones';
        if (path.startsWith('/msedcl')) return 'MSEDCL Documents';
        if (path.startsWith('/quotations')) return 'Quotations';
        if (path.startsWith('/user-management')) return 'User Management';
        if (path.startsWith('/reports')) return 'Reports';
        return 'Profit Pannels';
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    const userMenuItems = [
        {
            key: 'profile',
            label: 'My Profile',
            icon: <UserOutlined />,
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: 'Logout',
            icon: <LogoutOutlined />,
            danger: true,
            onClick: handleLogout,
        },
    ];

    return (
        <AntHeader
            style={{
                padding: 0,
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingRight: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                position: 'sticky',
                top: 0,
                zIndex: 1,
                width: '100%',
            }}
        >
            <Space>
                {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                    className: 'trigger',
                    onClick: () => setCollapsed(!collapsed),
                    style: {
                        fontSize: '18px',
                        padding: '0 24px',
                        cursor: 'pointer',
                        transition: 'color 0.3s',
                    },
                })}
                <Text strong style={{ fontSize: '18px' }}>
                    {getPageTitle(location.pathname)} | {user.role || 'System Administrator'}
                </Text>
            </Space>

            <Space size="large">
                <Button
                    type="text"
                    icon={<BellOutlined style={{ fontSize: '18px' }} />}
                />
                <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                    <Space style={{ cursor: 'pointer' }}>
                        <Avatar icon={<UserOutlined />} />
                        <Text>{user.fullName || 'User'}</Text>
                    </Space>
                </Dropdown>
            </Space>
        </AntHeader>
    );
};

export default Header;
